import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AISeoGenerateRequest as SchemaAISeoGenerateRequest } from '../schemas/AISeoGenerateRequest';
import { type GenerateAISeoShortResponse as SchemaGenerateAISeoShortResponse } from '../schemas/GenerateAISeoShortResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Pages
 */
export const GenerateAISeoForProductPageContentType = 'application/json' as const;
export type GenerateAISeoForProductPageRequest = SchemaAISeoGenerateRequest;
export type GenerateAISeoForProductPageResponses = LinkCommonErrorResponses & {
    /**
     * @description Успешная генерация сео текстов
     */
    '200': {
        'application/json': SchemaGenerateAISeoShortResponse;
    };
};
export type GenerateAISeoForProductPageResponseSuccess =
    GenerateAISeoForProductPageResponses['200']['application/json'];
export type GenerateAISeoForProductPageSearchParams = undefined;
export type GenerateAISeoForProductPagePathParameters = undefined;
export const GenerateAISeoForProductPageUrl = '/pages/products/seo/ai/generate' as const;
export const GenerateAISeoForProductPageMethod = 'POST' as const;
export const getGenerateAISeoForProductPageUrl = (_params?: GenerateAISeoForProductPagePathParameters) =>
    GenerateAISeoForProductPageUrl;
